module.exports = __webpack_public_path__ + "media/images/subject_img/MODERN LANGUAGES-dd1fe051d7a0e484dce9ff487a3eeca0.jpg";